import React from "react";
import { Tasks } from "./components/Tasks";
import { Button, Divider, Flex, Text } from "@chakra-ui/react";
import Status from "./components/Status/Status";
import GapAnalysis from "./components/GapAnalysis/GapAnalysis";
import { useSelector } from "react-redux";
import AIDashboard from "./components/AIDashboard/AIDashboard";
import IssbContainer from "../IssbContainer";
import PageHeader from "components/text/PageHeader";
import RoundList from "../components/NavItems/RoundList";
import useAirUserRoles from "../../../utils/AuthUtils";
import { routes } from "../../../config";
import { useNavigate } from "react-router-dom";

const IssbDashboard = () => {
  const roundSelector = useSelector((state) => state.issbRound);
  const { isOrgAdmin, canAccessEntity } = useAirUserRoles();
  const navigate = useNavigate();

  const handleStartRound = () => {
    navigate(routes.issbQuestionnaireRoundSetup);
  };

  const questionList = roundSelector?.questions;

  if (!canAccessEntity()) {
    return (
      <IssbContainer margin="15%">
        <Text>You don't have access to this entity</Text>
      </IssbContainer>
    );
  }

  return (
    <IssbContainer margin="15%">
      {roundSelector?.selectedRound ? (
        <Flex direction="column" gap={6}>
          <PageHeader title="Status" />
          <Text maxW="75%" color="gray.500" fontSize="body.m">
            This dashboard provides a real-time view of progress to meeting disclosure requirements. Stay on top of your
            reporting with clear insights into what needs your attention next.
          </Text>
          <Tasks questions={questionList} />
          <Status questions={questionList} />
        </Flex>
      ) : (
        <div>
          <Text color="darkTeal" fontSize="body.m" my={4}>
            Please select a round to get started
          </Text>
          <RoundList variant="secondary" />
          <Divider mt={4} mb={4} />
          {isOrgAdmin && (
            <div>
              Or{" "}
              <Button ml={2} variant="secondary" onClick={handleStartRound}>
                Create a new round
              </Button>
            </div>
          )}
        </div>
      )}
    </IssbContainer>
  );
};

export default IssbDashboard;
